/**
 * Integrations API (integration config and health).
 * Uses transport only; types from types/settings/integrationConfig.
 */

import type {
  IntegrationConfig,
  IntegrationType,
  IntegrationStatus,
  IntegrationValidateResult,
  IntegrationHealthResult,
} from '@repo/shared-types/settings/integrationConfig';
import { apiTransport } from './transport';
import { getContext } from './core';

export const integrationsApi = {
  list: async (): Promise<IntegrationConfig[]> => {
    const data = await apiTransport.get<IntegrationConfig[] | null>('/integration-settings', getContext());
    return Array.isArray(data) ? data : [];
  },
  getByType: async (type: string): Promise<IntegrationConfig | null> => {
    return apiTransport.get<IntegrationConfig | null>(`/integration-settings/type/${type}`, getContext());
  },
  save: async (config: IntegrationConfig): Promise<IntegrationConfig> => {
    return apiTransport.post<IntegrationConfig>('/integration-settings', config, getContext());
  },
  delete: async (id: string): Promise<{ success: boolean }> => {
    return apiTransport.delete<{ success: boolean }>(`/integration-settings/${id}`, getContext());
  },
  validate: async (type: IntegrationType, config: IntegrationConfig): Promise<IntegrationValidateResult> => {
    return apiTransport.post<IntegrationValidateResult>('/integration-settings/validate', { type, config }, getContext());
  },
  checkHealth: async (type: IntegrationType): Promise<IntegrationHealthResult> => {
    return apiTransport.post<IntegrationHealthResult>('/integration-settings/health', { type }, getContext());
  },
  updateStatus: async (
    type: IntegrationType,
    status: IntegrationStatus,
    error?: string
  ): Promise<{ success: boolean }> => {
    return apiTransport.post<{ success: boolean }>('/integration-settings/status', { type, status, error }, getContext());
  },
};

